import { render, staticRenderFns } from "./mdf-assign-users-widget.vue?vue&type=template&id=53279696&"
import script from "./mdf-assign-users-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-assign-users-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-assign-users-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports